import React from 'react';
import { WhiteSection } from 'components/base/layout-components';
import { SPACES } from 'common/constants/sizes';
import ServicesHeader from './ServicesHeader';
import ServiceRow from './Service/ServiceRow';
import useServices from './useServices';
import useServicesList from './useServicesList';

const Services = ({ selectionProps, readonly }) => {
  const { services, toggleServiceFormModal, onDelete } = useServices();

  const servicesList = useServicesList({
    services,
    selectionProps,
    onDelete,
    toggleServiceFormModal
  });

  return (
    <WhiteSection t={SPACES['x-medium']}>
      <ServicesHeader
        services={services}
        toggleServiceFormModal={toggleServiceFormModal}
        readonly={readonly}
        selectionProps={selectionProps}
      />
      {servicesList.map(service => (
        <ServiceRow
          key={service.id}
          service={service}
          readonly={readonly}
          onEdit={service.onEdit}
          onDelete={service.onDelete}
          isChecked={service.isChecked}
          onCheck={service.onCheck}
        />
      ))}
    </WhiteSection>
  );
};

export default Services;
